import $ from "jquery";

const homepage = () => {
  const init = () => {
    Popup();
    clearLocalStorage();
    PopupLogin();
    checkPrevDivUnvailable();
  };

  const homePage = ".mi-Homepage__Container";
  const chapter = ".mi-ChapterWrapper";
  const popupStar = ".js-ChapterWrapper__Popup";
  const popupCloseButton = ".mi-ChapterWrapper__Popup button.popup-close-button";
  const read = ".mi-Homepage__Container_Overview__Row_Col__Dashboard_Info__Btn";
  const popupLogout = ".js-PopupLogout";
  const popupLogoutClose = ".mi-Popup__Logout_Container .js-PopupLogout_Btn";
  const btnLogout = ".js-btnLogout";
  const btnBackLogout = ".mi-Popup__Logout_Container .js-PopupButton__Back";

  if ($(homePage).length === 0) return;

  // hide initially
  $(popupStar).hide();
  $(popupLogout).hide();

  const actionShow = (el) => {
    const target = el.data("target");
    $(popupStar).hide();
    $(`#${target}`).show();
  };

  // const handleClose = (e) => {
  //   if (
  //     !$(popupCloseButton).is(e.target) &&
  //     $(popupCloseButton).has(e.target).length === 0
  //   ) {
  //     $(popupStar).hide();
  //     removeEventListener();
  //   }
  // };

  const PopupLogin = () => {
    $(document).on('click', btnLogout, function () {
      $(popupLogout).show();
    })
    $(document).on('click', `${popupLogoutClose}, ${btnBackLogout}, .js-PopupLogout__Overlay`, function () {
      $(popupLogout).hide();
    })
  }

  const Popup = () => {
    $(chapter).on("click", function () {
      actionShow($(this));
    });
  };

  const clearLocalStorage = () => {
    $(read).on("click", function () {
      localStorage.removeItem("progress");
    });
  };

  // const removeEventListener = () => {
  //   $(document).off("click", handleClose);
  // };

  // $(document).on("click", handleClose);

  // close popup
  $(document).on("click", popupCloseButton, function () {
    const id = $(this).closest(popupStar).attr('id')
    $('#' + id).hide();
  });

  const checkPrevDivUnvailable = () => {
    $(window).on('load', function () {
      const chapterUnavailable = $('.js-chapterUnavailable');
      const prevDivArray = chapterUnavailable.prev().prev('.mi-Homepage__Container_Overview__Row_Col__Chapters_Child');
      const firstPrevDiv = prevDivArray[0];

      $(firstPrevDiv).addClass('prev-chapterUnavailable');
    })
  }

  init();
};

homepage();